export default __webpack_public_path__ + "static/media/img-dashboard.fd251ced.jpg";